import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Electrician/Electrician.css"
import img1 from "../../assets/images/AC/AC-317.jpg"
import img2 from "../../assets/images/AC/AC-318.webp"
import img3 from "../../assets/images/AC/AC-319.jpeg"
import img4 from "../../assets/images/AC/AC-320.jpeg"
import img5 from "../../assets/images/AC/AC-321.png"
import img6 from "../../assets/images/AC/AC-322.png"
import img7 from "../../assets/images/AC/AC-323.png"
const ACMachine = ({ cart, addToCart }) => {
  const [openService, setOpenService] = useState(null);
  const navigate = useNavigate();
  const services = [
    {
      id: 301,
      title: "Split AC installation (2 ACs)",
      price: 2400,
      subtitle: "Professional installation with proper alignment & safety check",
      extra_detail_1: "Install two split AC units safely and properly.",
      extra_detail_2: "Ensures secure fitting and efficient cooling performance. ❄️",
      image: "https://ea-unboxed-assets.croma.com/cromaunboxed-as/2024/07/split-AC-unit-lead-image-scaled.jpg"
    },
    {
      id: 302,
      title: "Foam-jet service (2 ACs)",
      price: 990,
      subtitle: "Deep cleaning improves cooling & air quality",
      extra_detail_1: "Deep foam-jet cleaning for two AC units.",
      extra_detail_2: "Removes dirt and improves cooling efficiency.",
      image: "https://volttap.in/wp-content/uploads/2025/11/download_db7ac944-9aea-4fe0-81ef-dc325943bead.jpg"
    },
    {
      id: 303,
      title: "Foam-jet service",
      price: 549,
      subtitle: "Deep foam cleaning for better cooling & hygiene",
      extra_detail_1: "Deep foam-jet cleaning for effective AC maintenance.",
      extra_detail_2: "Removes dirt and improves cooling performance.",
      image: "https://volttap.in/wp-content/uploads/2025/11/download_db7ac944-9aea-4fe0-81ef-dc325943bead.jpg"
    },
    {
      id: 304,
      title: "General AC service",
      price: 659,
      subtitle: "Basic cleaning to maintain cooling efficiency",
      extra_detail_1: "Clean filters and check AC for smooth performance",
      extra_detail_2: "Ensure efficient cooling and proper airflow",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRaYn59Mz-QRr8uDSZUpjm4ts3t44bQadXB2w&s"
    },
    {
      id: 305,
      title: "Indoor Coil Deep Cleaning",
      price: 699,
      subtitle: "Removes dust, improves airflow & cooling",
      extra_detail_1: "Deep clean indoor coil to remove dust buildup",
      extra_detail_2: "Improves cooling efficiency and airflow performance",
      image: "https://tiimg.tistatic.com/fp/1/004/249/split-ac-indoor-cooling-coils-547.jpg"
    },
    {
      id: 306,
      title: "Outdoor Unit Service",
      price: 499,
      subtitle: "Outdoor fan & condenser cleaning",
      extra_detail_1: "Servcice and clean the outdoor AC unit properly",
      extra_detail_2: "Improves cooling efficiency and unit performance",
      image: "https://5.imimg.com/data5/SELLER/Default/2021/1/FP/RJ/QK/90950626/outdoor-unit-kit-500x500.jpeg"
    },
    {
      id: 307,
      title: "Low / No Cooling Repair",
      price: 299,
      subtitle: "Complete inspection & fixing",
      extra_detail_1: "Repair AC issues causing low or no cooling.",
      extra_detail_2: "Restores proper cooling and airflow performance.",
      image: "https://5.imimg.com/data5/WL/KW/OE/SELLER-86563692/split-ac-outdoor-unit.jpg"
    },
    {
      id: 308,
      title: "AC Power Issue Repair",
      price: 259,
      subtitle: "Fixing power, startup & sudden shutdown issues",
      extra_detail_1: "Fix AC power issues and electrical faults.",
      extra_detail_2: "Restores safe power supply and smooth operation.",
      image: "https://go.dodobooker.com/wp-content/uploads/2024/04/R3u11675922851289-5511zon.jpg"
    },
    {
      id: 309,
      title: "Water Leakage Repair",
      price: 459,
      subtitle: "Fix for indoor / outdoor water leakage problem",
      extra_detail_1: "Fix AC water leakage quickly and effectively.",
      extra_detail_2: "Prevents damage and restores proper drainage.",
      image: "https://go.dodobooker.com/wp-content/uploads/2024/04/R3u11675922851289-5511zon.jpg"
    },
    {
      id: 310,
      title: "Gas Refill + Cooling Check",
      price: 2500,
      subtitle: "Refilling with pressure & leakage test",
      extra_detail_1: "Refill AC gas and check cooling performance.",
      extra_detail_2: "Ensures efficient cooling and proper refrigerant levels.",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpGcSD7fAtYWRClIN8GMJGZ2nirENVFbLCfw&s"
    },
    {
      id: 311,
      title: "PCB / Sensor Repair",
      price: 799,
      subtitle: "Fix for motherboard & sensor problems",
      extra_detail_1: "Repair faulty PCB boards or malfunctioning sensors.",
      extra_detail_2: "Restores proper AC control and system performance.",
      image: "https://5.imimg.com/data5/QQ/TA/MY-10309039/ac-pcb.jpg"
    },
    {
      id: 312,
      title: "Noise / Smell Fix",
      price: 499,
      subtitle: "Fix for vibration, smell & sound issues",
      extra_detail_1: "Eliminate unusual AC noise and smell",
      extra_detail_2: "Fix vibration and airflow related issues",
      image: "https://public.carlcare.com/public/0bfd8af43fa77a4927e14ea207fb2d1b.jpg"
    },
    {
      id: 313,
      title: "Split AC Installation",
      price: 1500,
      subtitle: "Secure installation + Demo provided",
      extra_detail_1: "Install split AC unit safely",
      extra_detail_2: "Ensure proper cooling and setup",
      image: "https://public.carlcare.com/public/0bfd8af43fa77a4927e14ea207fb2d1b.jpg"
    },
    {
      id: 314,
      title: "Window AC Installation",
      price: 799,
      subtitle: "Strong & safe fitting",
      extra_detail_1: "Install window AC with secure fitting",
      extra_detail_2: "Ensure stable support and airflow",
      image: "https://www.lg.com/content/dam/channel/wcms/in/images/window-ac/uw-q18wuza_aslg_eail_in_c/gallery/UW-Q18WUZA-2010X1334.jpg/jcr:content/renditions/thum-1600x1062.jpeg"
    },
    {
      id: 315,
      title: "Split AC Uninstallation",
      price: 569,
      subtitle: "Safe removal with care",
      extra_detail_1: "Remove split AC unit carefully",
      extra_detail_2: "Disconnect wiring and pipes safely",
      image: "https://famcocorp.ae/wp-content/uploads/2024/05/AC-Split.webp"
    },
    {
      id: 316,
      title: "Window AC Uninstallation",
      price: 699,
      subtitle: "Quick safe removal",
      extra_detail_1: "Remove window AC safely and quickly",
      extra_detail_2: "Avoid wall damage during removal",
      image: "https://www.lg.com/content/dam/channel/wcms/in/images/window-ac/uw-q18wuza_aslg_eail_in_c/gallery/UW-Q18WUZA-2010X1334.jpg/jcr:content/renditions/thum-1600x1062.jpeg"
    },
    {
      id: 317,
      title: "Air Cooler Check-up",
      price: 249,
      subtitle: "Basic inspection service",
      extra_detail_1: "Complete cooler condition check",
      extra_detail_2: "Identify issues and recommend fixes",
      image: img1
    },
    {
      id: 318,
      title: "Motor Air Cavity Removal",
      price: 99,
      subtitle: "Dust & blockage cleaning",
      extra_detail_1: "Remove dirt from motor air cavity",
      extra_detail_2: "Improve airflow and performance",
      image: img2
    },
    {
      id: 319,
      title: "Foam-Jet Service (3 ACs)",
      price: 1497,
      subtitle: "Deep cleaning for 3 AC units",
      extra_detail_1: "High-pressure foam jet cleaning",
      extra_detail_2: "Removes dirt, bacteria & improves cooling",
      image: img3
    },
    {
      id: 320,
      title: "Foam-Jet Service (4 ACs)",
      price: 1796,
      subtitle: "Deep cleaning for 4 AC units",
      extra_detail_1: "Complete internal cleaning using foam jet",
      extra_detail_2: "Enhances cooling efficiency",
      image: img4
    },
    {
      id: 321,
      title: "Foam-Jet Service (5 ACs)",
      price: 2245,
      subtitle: "Deep cleaning for 5 AC units",
      extra_detail_1: "Advanced foam cleaning for multiple units",
      extra_detail_2: "Removes dust, mold & improves airflow",
      image: img5
    },
    {
      id: 322,
      title: "Window AC Frame Uninstallation",
      price: 99,
      subtitle: "Frame removal service",
      extra_detail_1: "Careful removal of AC frame",
      extra_detail_2: "Prevents wall and window damage",
      image: img6
    },
    {
      id: 323,
      title: "AC Repair",
      price: 299,
      subtitle: "General AC repair service",
      extra_detail_1: "Diagnose and fix AC issues",
      extra_detail_2: "Includes minor repairs and adjustments",
      image: img7
    }
  ];

  return (
    <div className="container-fluid service-electrician">
      <div id="Electronic">
        <h1>AC Machine Services</h1>
      </div>
      <div className="elect-container">

        {/* LEFT SIDE - SERVICES */}
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}

                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default ACMachine